export const spacing = (factor: number): string => `${0.25 * factor}rem`
